import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-brand px-5 py-16 sm:py-20" data-id="element-101" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-xl text-center" data-id="element-102" data-mp="1o5q2iivokc11">
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-lime text-brand" data-id="element-103" data-mp="223ob17nble8m">
          <ShieldCheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-104" data-mp="1x5d1ky0xt5qx" />
        </span>
        <h2 className="mt-6 font-display text-xl font-black uppercase tracking-wide text-white sm:text-2xl" data-id="element-105" data-mp="19dzcd0y31qa6">
          Get Your Money Back Or Keep Everything
        </h2>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-white/70" data-id="element-106" data-mp="1j4k8mhqaaipx">
          Try Tennis Ready for a full 7 days. Browse every volume, run the
          sessions, and use the blueprints on court. If you don&apos;t save
          hours of planning or feel more prepared as a coach, simply email us
          and we&apos;ll refund every dollar. No questions asked.
        </p>
        <a href="#faq" className="mt-5 inline-block text-xs font-bold text-lime underline underline-offset-4 transition-colors hover:text-white" data-id="element-107" data-mp="lnbze19b8agr">
          Full refund policy
        </a>
      </div>
    </section>;
}